<div class="form-card" [class.editing]="editingId() !== null">
  <form [formGroup]="form" class="suggestion-form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="type-field">
        <mat-label>{{ 'gdp.suggestions.type' | translate }}</mat-label>
        <mat-select formControlName="type">
          @for (type of suggestionTypes(); track type) {
            <mat-option [value]="type">{{ 'gdp.suggestions.type.' + type | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="title-field">
        <mat-label>{{ 'gdp.suggestions.suggestion-title' | translate }}</mat-label>
        <input matInput formControlName="title" maxlength="255">
      </mat-form-field>
    </div>

    <!-- QA Feedback: tarea destino obligatoria -->
    @if (form.controls.type.value === 'QA_FEEDBACK') {
      <mat-form-field appearance="outline" class="qa-task-field">
        <mat-label>{{ 'gdp.suggestions.qa-task' | translate }}</mat-label>
        <mat-select formControlName="taskId">
          @for (task of qaTasks(); track task.taskId) {
            <mat-option [value]="task.taskId">
              {{ task.reference }} · {{ task.name }} (SP{{ task.sprintNumber }})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <label class="field-label">{{ 'gdp.suggestions.text' | translate }}</label>
    <app-quill-editor formControlName="text"></app-quill-editor>

    <!-- Adjuntos pendientes (se suben al enviar): misma lista con miniaturas,
         editor de imagen y diagramas reabribles que el detalle de tarea -->
    <div class="pending-attachments">
      <app-file-attachment-list
        [attachments]="pendingAttachments()"
        [canEdit]="true"
        [showEmptyMessage]="false"
        [hasExtraThumbs]="true"
        [previewLoader]="pendingFileLoader"
        (upload)="addPendingFiles($event)"
        (download)="downloadPendingFile($event)"
        (delete)="removePendingFile($event)"
        (imageEdited)="onPendingImageEdited($event)">
        <button attachment-extra-action mat-stroked-button type="button"
                (click)="pendingDiagramListRef.createDiagram()">
          <mat-icon>account_tree</mat-icon>
          {{ 'gdp.diagrams.add' | translate }}
        </button>
        <app-diagram-list #pendingDiagramListRef extra-thumbs [flat]="true"
          [diagrams]="pendingDiagramItems()"
          [canEdit]="true"
          [showActions]="false"
          [showEmptyMessage]="false"
          [previewLoader]="pendingDiagramPreviewLoader"
          [contentLoader]="pendingDiagramContentLoader"
          (save)="onPendingDiagramSave($event)"
          (delete)="removePendingDiagram($event)">
        </app-diagram-list>
      </app-file-attachment-list>
    </div>

    <div class="form-actions">
      @if (editingId() !== null) {
        <button mat-button type="button" (click)="resetForm()">{{ 'common.cancel' | translate }}</button>
      }
      @if (isEditingSent()) {
        <!-- Ya enviada: solo se guardan los cambios (el estado no se toca) -->
        <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="submit()">
          <mat-icon>save</mat-icon>
          {{ 'common.save' | translate }}
        </button>
      } @else {
        @if (form.controls.type.value !== 'QA_FEEDBACK') {
          <button mat-stroked-button type="button" [disabled]="form.invalid" (click)="submit(true)">
            <mat-icon>drafts</mat-icon>
            {{ 'gdp.suggestions.save-draft' | translate }}
          </button>
        }
        <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="submit(false)">
          <mat-icon>send</mat-icon>
          {{ 'gdp.suggestions.submit' | translate }}
        </button>
      }
    </div>
  </form>
</div>
